(function () {
  // Toggle content
  $(document).on("click", ".product-description-more", function (e) {
    e.preventDefault();
    $(this)
      .closest(".product-description-short")
      .next(".product-description-full")
      .show();
    $(this).closest(".product-description-short").hide();
  });

  $(document).on("click", ".product-description-less", function (e) {
    e.preventDefault();
    $(this)
      .closest(".product-description-full")
      .prev(".product-description-short")
      .show();
    $(this).closest(".product-description-full").hide();
  });

  // Toggle fields
  $(document).on("click", ".js-show-more", function (e) {
    e.preventDefault();
    $(this).siblings("input").removeClass("hidden");
    $(this).siblings("label").removeClass("hidden");
    $(this).remove();
  });
})();

/* Second floated product form */
if (!customElements.get("floated-form")) {
  class FloatedForm extends HTMLElement {
    constructor() {
      super();
      this.renderForm();
    }

    renderForm() {
      fetch(this.getAttribute("data-product-url"))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          this.productElement = responseHTML.querySelector(
            'div[id^="ProductInfo-"]'
          );

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.showMoreFields();
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(
          document.createTextNode(oldScriptTag.innerHTML)
        );
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
        sectionId,
        `floated-${sectionId}`
      );

      if (this.productElement.querySelectorAll("variant-selects")) {
        this.productElement
          .querySelectorAll("variant-selects")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }

      if (this.productElement.querySelectorAll("variant-radios")) {
        this.productElement
          .querySelectorAll("variant-radios")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }
    }

    removeDOMElements() {
      const removeSelectors = [
        ".product__text",
        ".share-buttons",
        ".rating",
        ".product-tags",
        ".product__description",
        ".note",
        ".promo-banner",
        ".custom-liquid",
        ".customer",
        // Half Past Fur custom right-column blocks
        ".hpf-features-grid",
        ".hpf-perfect",
        ".hpf-meta-row",
        ".hpf-trust-item",
      ];
      removeSelectors.forEach((sel) => {
        this.productElement.querySelectorAll(sel).forEach((el) => el.remove());
      });

      const advantages = this.productElement.querySelectorAll(".advantage");
      advantages.forEach((advantage) => advantage.remove());

      const pickupAvailability = this.productElement.querySelector(
        "pickup-availability"
      );
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector("product-modal");
      if (productModal) productModal.remove();

      const productForm = this.productElement.querySelector("floated-form");
      if (productForm) productForm.remove();

      const relatedProduct =
        this.productElement.querySelector("related-product");
      if (relatedProduct) relatedProduct.remove();
    }

    showMoreFields() {
      $(".js-show-more").click(function (e) {
        e.preventDefault();
        $(this).siblings("input").removeClass("hidden");
        $(this).siblings("label").removeClass("hidden");
        $(this).remove();
      });
    }
  }

  customElements.define("floated-form", FloatedForm);
}
